import { ConsoleDebug } from "./ConsoleDebug";

export class PactoHelper {


  triggerEvent(event) {
    console.log('[PactoHelper] triggerEvent event', event);
    document.dispatchEvent(event);
  }

  waitForElm(selector, target = document.body, subtree = false) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        observer.observe(target, {
            childList: true,
            subtree: subtree
        });
    });
  }

  waitForObj(objName) {

   let logInstance = new ConsoleDebug('debug-pianohelper', 'PianoHelper');
    logInstance.log('[PactoHelper] objName ', objName);
    let oldSchoolWaiterCount = 0;
    return new Promise( (resolve, reject) => {
      logInstance.log('[PactoHelper] start waitForObj Promise');

      if(window[objName] != undefined) {
        logInstance.log('[PactoHelper] '+objName+' is available ', window[objName]);
        resolve();
      } else {
        const oldSchoolWaiter = setInterval(function () {

          logInstance.log('[PactoHelper] typeof '+objName , typeof objName);

          if (typeof window[objName] !== "undefined") {
            logInstance.log('[PactoHelper] '+objName+' is available '+oldSchoolWaiterCount , window[objName]);
            resolve();
            clearInterval(oldSchoolWaiter)
          } else if (oldSchoolWaiterCount > 10) {
            clearInterval(oldSchoolWaiter);
            logInstance.log('[PactoHelper] Timeout erreicht ');
            reject('Timeout erreicht');
          } else {
            oldSchoolWaiterCount++
            logInstance.log('[PactoHelper] oldSchoolWaiterCount ', oldSchoolWaiterCount);
          }
        }, 900);
      }
    })
  }

  static isPromise(promise) {
    return !!promise && typeof promise.then === 'function'
  }

  static sanitizeString(string) {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#x27;',
      "/": '&#x2F;',
    };
    const reg = /[&<>"'/]/ig;
    return string.replace(reg, (match)=>(map[match]));
  }
}

